import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ChannelGroupPermissionGate = (props: Omit<BasePermissionGateProps<"channel">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="channel"
		/>
	)
}

export default ChannelGroupPermissionGate
